import { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import Icon from "../../assets/components/icon";
import { translateMenu } from "../../constants/defaultText";
import AuthContext from "../../context/auth";
import { signOutUser } from "../../hooks/firebase/signOut";
import logoBig from "../../assets/images/logo.png";
import { Image } from "react-bootstrap";
import { UserMenu } from "../../types/authTypes";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userMenu } = useContext(AuthContext);

  const menu = userMenu as unknown as UserMenu[];

  return (
    <div className="sidebar-wrapper ">
      <div className="logo" onClick={() => navigate("/")}>
        {/* <Icon icon="logo-light" className="sidebar-logo-big" />
        <Icon icon="logo-icon" className="sidebar-logo-icon" /> */}
      </div>

      <ul className="nav ">
        {menu
          .filter((route: any) => route.type === "sidebar")
          .map((menu: any) => (
            <li key={menu.name}>
              <NavLink
                to={menu.to}
                className={({ isActive }: { isActive: boolean }) => {
                  return isActive ? "active nav-item " : "nav-item";
                }}
              >
                <Icon icon={menu.icon} className="nav-item-icon" />
                <span className="nav-item-text">
                  {translateMenu(menu.label || menu.name)}
                </span>
              </NavLink>
            </li>
          ))}

        <li>
          <NavLink
            to="/signin"
            className={({ isActive }: { isActive: boolean }) => {
              return isActive ? "active nav-item" : "nav-item";
            }}
            onClick={signOutUser}
          >
            <Icon icon="logout" className="nav-item-icon" />
            <span className="nav-item-text">Uitloggen</span>
          </NavLink>
        </li>
      </ul>
      <div className="logo-container">
        <Image
          onClick={() => location.pathname !== "/dashboard" && navigate("/")}
          src={logoBig}
          className="logo-icon"
        />
        <Image
          onClick={() => location.pathname !== "/dashboard" && navigate("/")}
          src={logoBig}
          className="logo-big"
        />
      </div>
    </div>
  );
};

export default Sidebar;
